<div class="container footer">
    <div class="buttons">
      <div class="button-div">
        <button [class]="contactClicked ? 'title-button-active' : 'title-button'"
                (click)="contactClicked = !contactClicked;">{{ 'footer.contact' | translate }}</button>
        <div class="arrow" *ngIf="contactClicked"></div>
      </div>
    </div>
    <div *ngIf="contactClicked">
      <ul class="info m-0">
        <li class="info-detail">{{ 'footer.phone' | translate }}: <a class="details" href="tel:+3614864343">06 1 486 4343</a></li>
        <li class="info-detail">{{ 'footer.email' | translate }}: <a class="details" href="mailto:ugyfelszolgalat@union.hu">ugyfelszolgalat&#64;union.hu</a></li>
        <li class="info-detail"><a class="details" (click)="openNewPage('openingHours')">{{ 'footer.openingHours' | translate }}</a></li>
        <li class="info-detail"><a class="details" (click)="openNewPage('complaintHandling')">{{ 'footer.complaintHandling' | translate }}</a></li>
      </ul>
    </div>

    <ul class="info m-0">
      <li class="info-detail"><a class="details" (click)="openNewPage('dataProtection')">{{ 'footer.dataProtection' | translate }}</a></li>
      <li class="info-detail"><a class="details" (click)="showCookie()">{{ 'footer.cancelCookie' | translate }}</a></li>
    </ul>

    <div class="about">
      {{ 'footer.about' | translate }}<br>
      <a class="details" (click)="openNewPage('moreAboutOnlinePayment')">{{ 'footer.more' | translate }}</a><br><br>
      {{ 'footer.merchant' | translate }}:
      <a class="details" (click)="openNewPage('unionContacts')">{{ 'footer.union' | translate }}</a>
      {{ 'footer.callCenter' | translate }}: (06 1) 486 4343
      <div class="icons flex-center">
        <a class="details" (click)="openNewPage('cibHu')"><img class="icon" src="assets/credit-card/SVG/CIB_logo.svg" alt="cibbank"></a>
        <img class="icon" src="assets/credit-card/SVG/mastercard.svg" alt="mastercard">
        <img class="icon" src="assets/credit-card/SVG/maestro.svg" alt="maestro">
        <img class="icon" src="assets/credit-card/SVG/mc_installment_hu.svg" alt="mastercard_installment">
        <img class="icon" src="assets/credit-card/SVG/mc_idcheck.svg" alt="mastercard_id_check">
        <img class="icon" src="assets/credit-card/SVG/visa.svg" alt="visa">
        <img class="icon visa" src="assets/credit-card/SVG/vpay.svg" alt="visa_pay">
        <img class="icon visa" src="assets/credit-card/SVG/visa_secure.svg" alt="visasecure">
      </div>
    </div>
    <div>
      <img class="union-logo-footer" src="assets/union/footer-logo.png" alt="union-logo-footer">
      <div class="copyright">
        {{ 'footer.copyright' | translate }}
        <br>
        <a *ngIf="!isProduction" class="details" (click)="openNewPage('CHANGELOG')">
          version: 0.1.0.7
        </a>
      </div>
    </div>
  </div>
